import React, { useCallback, useMemo, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { connect } from 'react-redux';
import {
	resetSiginRedirect,
	switchToAccount,
} from '../../actions/HeaderActions';
import { resetAccessRemoved, signOut } from '../../actions/index';
import { switchBack } from '../../actions/ShopManagerActions';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { clearUserLocalStorage } from '../../utils/helper';
import DefaultAvatar from '../../Markup/assets/img/bruce-mars-AndE50aaHn4-unsplash 1.png';

const ProfileDropdown = props => {
	const [is_dropDown_open, setIs_dropDown_open] = useState(false);
	const { user, switched_user, userSignOut } = props;

	const signOut = useCallback(() => {
		clearUserLocalStorage();
		userSignOut();
		props.history.push('/auth/sign-in');
	}, [props.history, userSignOut]);

	const name = useMemo(() => {
		if (user) {
			return (
				user?.display_name ||
				user?.name ||
				user?.first_name + ' ' + user?.last_name
			);
			// return user.display_name
			// 	? user.display_name
			// 	: user.name
			// 		? user.name
			// 		: user.first_name +
			// 		' ' +
			// 		user.last_name;
		}
		return 'No name';
	}, [user]);

	return (
		<div className="wp-checkout-profile-name-dropdown">
			<Dropdown
				className="dropdown WpdProfileControl "
				onClick={() => setIs_dropDown_open(!is_dropDown_open)}
				show={is_dropDown_open}
			>
				<Dropdown.Toggle
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
					className="WpdProfileControlButton"
					variant="outline-light"
					id="profile-dropdown"
				>
					<div className="WpdProfileImage">
						<img
							src={
								user?.profile_image ||
								user?.gravatar ||
								DefaultAvatar
							}
							// src={
							// 	user &&
							// 		user.profile_image
							// 		? user.profile_image
							// 		: user &&
							// 			user.gravatar
							// 			? user.gravatar
							// 			: DefaultAvatar
							// }
							alt=""
						/>
					</div>
					<div className="WpdProfileDetails">
						{switched_user !== null && (
							<p
								style={{
									color: 'green',
									textAlign: 'right',
									fontSize: 13,
								}}
							>
								Your are logged in as:
							</p>
						)}
						<h4 className="WpdUserName">{name}</h4>
					</div>
				</Dropdown.Toggle>

				<Dropdown.Menu
					show={is_dropDown_open}
					className="dropdown-menu dropdown-menu-right WpdProfileDropdown"
				>
					<ul>
						{switched_user != null && (
							<li>
								<button
									onClick={() =>
										props.switchBack(switched_user.id)
									}
								>
									<span className="WpdNavigationIcon">
										<i className="wpd-icon wpd-swap"></i>
									</span>
									<span className="WpdNavigationText">
										Switch Back
									</span>
								</button>
							</li>
						)}
						<li>
							<Link to="/user/profile">
								<span className="WpdNavigationIcon">
									<i className="wpd-icon wpd-user"></i>
								</span>
								<span className="WpdNavigationText">
									Profile
								</span>
							</Link>
						</li>

						{props.switched_user === null && (
							<li>
								<button onClick={signOut}>
									<span className="WpdNavigationIcon">
										<i className="wpd-icon wpd-logout"></i>
									</span>
									<span className="WpdNavigationText">
										Logout
									</span>
								</button>
							</li>
						)}
					</ul>
				</Dropdown.Menu>
			</Dropdown>
		</div>
	);
};

const mapStateToProps = state => {
	return {
		activeProfile: state.auth.signin && state.auth.signin.activeProfile,
		switchSuccess: state.auth.accountSwitchSuccess,
		user: state.auth.signin && state.auth.signin.userInfo,
		switched_user: state?.auth?.signin?.switched_user ?? null,
		accountType: state.auth.signin && state.auth.signin.accountType,
		accessRemoved: state.auth && state.auth.accessRemoved,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		switchAccount: value => dispatch(switchToAccount(value)),
		resetRedirect: () => dispatch(resetSiginRedirect()),
		userSignOut: () => dispatch(signOut()),
		resetAccessRemoved: () => dispatch(resetAccessRemoved()),
		switchBack: id => dispatch(switchBack(id)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileDropdown);
